import { useSiteSettings } from "@/contexts/SiteSettingsContext";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { X, Megaphone } from "lucide-react";

export default function AnnouncementBar() {
  const { settings } = useSiteSettings();
  const loc = useLocation();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setHidden(sessionStorage.getItem("w2e_ann_dismissed") === "1");
  }, []);

  if (loc.pathname.startsWith("/admin")) return null;
  const a = settings?.announcement;
  if (!a?.active || !a?.text) return null;
  if (hidden) return null;

  const dismiss = () => {
    sessionStorage.setItem("w2e_ann_dismissed", "1");
    setHidden(true);
  };

  return (
    <div className="bg-[#0A192F] text-white text-sm" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Megaphone className="w-4 h-4 shrink-0 text-amber-300" />
          <span className="truncate">{a.text}</span>
          {a.cta_text && a.cta_link && (
            <Link
              to={a.cta_link}
              className="ml-2 shrink-0 text-white/90 hover:text-white underline underline-offset-2 font-medium"
              data-testid="announcement-cta"
            >
              {a.cta_text} →
            </Link>
          )}
        </div>
        <button onClick={dismiss} className="text-white/70 hover:text-white" aria-label="Dismiss" data-testid="announcement-dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
